module.exports = __webpack_public_path__ + "img/laptop-enhanced1.9d2db27d.png";